import Big from 'big.js'

const QUICK_MULTIPLIERS = [1, 1.5, 2, 3, 5]

type Props = {
  baseCurrencyCode: string
  minAmountInBaseCurrency: number | null
}

export const useQuickAmounts = ({ baseCurrencyCode, minAmountInBaseCurrency }: Props) => {
  if (!baseCurrencyCode || !minAmountInBaseCurrency) {
    return []
  }

  const quickAmounts = QUICK_MULTIPLIERS.map((multiplier, key) => ({
    value: new Big(minAmountInBaseCurrency).times(multiplier).round(2, 3).toNumber(),
    isMin: key === 0,
  }))

  return quickAmounts
}
